import Card from '@mui/material/Card'
import React, { useCallback, useEffect, useMemo } from 'react'
import CardContent from '@mui/material/CardContent'
import Booking from '../../Booking'
import { Link } from 'react-router-dom'
import {
    Box,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    Typography,
    makeStyles,
    Button
} from '@material-ui/core'
import calenderTick from '../../../../../assests/images/calenderTick.svg'
import closeIcon from '../../../../../assests/images/closeIcon.svg'

import SingleCalenderComp from '../../../../../shared/elements/DatePickerCustom/SingleCalenderComp'
import moment from 'moment'
import {
    endDateFilterToUTC,
    FilterToUTC,
    patientTimeZone,
    specialityOfPrivider,
    startDateFilterToUTC,
} from '../../../../../containers/AppointmentList/utils'
import {
    getAvailableAppointmentList,
    providerListForBook,
    requestGetAvatarUrl,
} from '../../../../../services/Appointments/appointments'
import LoadingNew from '../../../../../utilities/loading-page/LoadingNew'
import { ReactComponent as DeleteIcon } from '../../../../../assests/icons/closeIcon.svg'
import { useSelector } from 'react-redux'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import { calculateAge, checkTimeForToday, getNextTwoBusinessDays, isWeekend, nameAvatar, transLate } from '../../../../utils'
import NoProviderComponent from './NoProviderComponent'
import ProviderFilter from './ProviderFilter'
import { useNotification } from '../../../MaterialUi/Notification'
import { stateList } from '../../../../../containers/AppointmentBooking/constant'
import { DemoGraphModal } from '../DemographModal'
import CloseIcon from '@mui/icons-material/Close';
import {Dialog } from '@mui/material'
import SelectATime from '../../StepperComponents/SelectATime'
import ProviderDetails from './ProviderDetails'
import Modal from '@mui/material/Modal';
import { LoadingButton } from '@mui/lab'
import ReasonForVisitModal from '../ReasonForVisitModal'


const visitTypeMap = {
    'allergy & immunology':"ALLERGYINT",
    'cardiology': "CARDIOLOGYINT",
    'dermatology':  "DERMATOLOGYINT",
    'endocrinology': "ENDOCRINOLOGYINT",
    'gastroenterology':  "GASTROINT",
    'hepatology': "HEPATOLOGYINT",
    'infectious disease':'IDINT',
    'nephrology': 'NEPHROLOGYINT',
    'neurology':  'NEUROLOGYINT',
    'nutrition': 'NUTRITIONINT',
    'orthopedics': 'ORTHOINT',
    'ent/otolaryngology': 'OTOLARYNGOLOGYINT',
    'physical medicine & rehabilitation': 'PHYMEDINT',
    'physical therapy':  'PHYTHERAPYINT',
    'pulmonology':  'PULMONOLOGYINT',
    'rheumatology': 'RHEUMINT',
    'therapy':  "THERAPYINT",
    'psychiatryA': 'PSYINT',
    'psychiatryC':'PSYCHILDINT',
    'urology': 'UROLOGYINT',
       
  };

const Filters = ['Morning', 'Afternoon', 'Evening']

const useStyles = makeStyles(() => ({
    modalCss:{
        padding: '10px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        background: '#fff',
    },
    normalText:{
        fontFamily: 'Inter',
        fontSize: '18px', 
        fontWeight: 400,
        color: '#000000',
        lineHeight: 'auto',
        whiteSpace: 'normal',wordBreak: 'break-word'
    },
    therapyCheckBox:{
        display:'grid',
        gridTemplateColumns: '1fr 106px',
        ['@media (max-width:768px)']: {
            display: 'flex !important',
            flexDirection: 'column !important',
            gap: '10px'
        },
    }
}))

const ProviderINT = ({
    findYourCareValues,
    selectATimeValues,
    providerDetails,
    setProviderVisitType,
    returnedErrorMessage = false,
    setReturnedErrorMessage,
    clinicalPracticeNumber,
    handleSelectATimeValues,
    goToRequiredStep,
    checkDisableTime,
    setCheckDisableTime,
    maxDate,
    steps,
    setSteps,
    handleNextStep,
    isMobileView,
    backButton,
    reasonForVisitText,
    setReasonForVisitText,
    selctedProviderDetails,
    selectedTime,
}) => {
    const classes = useStyles()
    const notification = useNotification()
    const amdPatientDetails =  useSelector((state) => state?.patient?.amdPatientDetails)
    const PatientCreateObject = useSelector((state) => state?.patient?.patientCreateObject)
    const timeZoneOfPatient = useSelector((state) => state?.patient?.patientTimeZone)
    const patientAge = calculateAge(PatientCreateObject?.dob)
    const [timeBooking, setTimeBooking] = React.useState({
        0: false,
    })
    const [openCalender, setOpenCalender] = React.useState(false)
    const [displayDate, setDisplayDate] = React.useState(
        selectATimeValues?.date?.format('MM/DD/YYYY'),
    )
    const [timeSelected, setTimeSelected] = React.useState({
        0: false,
    })
    const [loading, setLoading] = React.useState(false)
    const [listOfProvider, setListOfProvider] = React.useState([])
    const [filterTime, setFilterTime] = React.useState({
        startTime: null,
        endTime: null,
    })
    const [visitType, setVisitType] = React.useState(null)
    const [availableList, setAvailableList] = React.useState([])
    const [appointmentList, setAppointmentList] = React.useState([])
    const [showErrorMessage, setShowErrorMessage] = React.useState(false)
    const [availabilityLoading, setAvailabilityLoading] = React.useState(false)
    const [providerDetailsModal, setProviderDetailsModal] = React.useState(false)
    const [providerDetailsForModal, setProviderDetailsForModal] = React.useState({})
    const [openReasonForvisit, setOpenReasonForvisit] = React.useState(false)
    const [openIntakeModal, setOpenIntakeModal] = React.useState(false)
    const [openIntakeTherapyModal, setOpenIntakeTherapyModal] = React.useState(false)

    const [filterProps, setFilterProps] = React.useState({
        open: false,
        filters: Filters.filter((item) => {
            if (selectATimeValues[item?.toLowerCase()]) return item
        }),
    })
    const [openModal, setOpenModal] = React.useState(false)

    const loggedinPatiendata = useSelector((state) => state?.login?.userData)
    const setSelectedTime = () => {
        const isToday = selectATimeValues?.date?.isSame(moment().tz('US/Pacific'), 'day')
        const nowPST = moment().tz('US/Pacific');
        const hour = nowPST.format('HH');
        const minute = nowPST.format('mm');
        if(isToday){
            if (
                (selectATimeValues?.morning &&
                    selectATimeValues?.afternoon &&
                    selectATimeValues?.evening) ||
                (selectATimeValues?.morning && selectATimeValues?.evening)
            ) {
                if (hour < 8) {
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    });
                  } else {
                    
                    return setFilterTime({
                      startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient, minute),
                      endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    });
                  }
            } else if (selectATimeValues?.morning && selectATimeValues?.afternoon) {
                
                if(hour < 8){
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                    })
                }else{
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient, minute),
                        endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                      });
                }
            } else if (selectATimeValues?.afternoon && selectATimeValues?.evening) {
                if(hour < 12){
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    })
                }else{
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient, minute),
                        endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    })
                }
            } else if (selectATimeValues?.morning) {
                if(hour < 8){
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                    })
                }else{
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient,minute),
                        endTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                    })
                }
            } else if (selectATimeValues?.afternoon) {
                if(hour < 12){
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                    })
                }else{
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient, minute),
                        endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                    })
                }
            } else if (selectATimeValues?.evening) {
                if(hour < 17){
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                        endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    })
                }else{
                    return setFilterTime({
                        startTime: FilterToUTC(displayDate, hour, timeZoneOfPatient, minute),
                        endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                    })
                }
            }else{
                return setFilterTime({
                    startTime: '',
                    endTime: '',
                })
            }
        }
        else{
            if (
                (selectATimeValues?.morning &&
                    selectATimeValues?.afternoon &&
                    selectATimeValues?.evening) ||
                (selectATimeValues?.morning && selectATimeValues?.evening)
            ) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                })
            } else if (selectATimeValues?.morning && selectATimeValues?.afternoon) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                })
            } else if (selectATimeValues?.afternoon && selectATimeValues?.evening) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                })
            } else if (selectATimeValues?.morning) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 8, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                })
            } else if (selectATimeValues?.afternoon) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 12, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                })
            } else if (selectATimeValues?.evening) {
                return setFilterTime({
                    startTime: FilterToUTC(displayDate, 17, timeZoneOfPatient),
                    endTime: FilterToUTC(displayDate, 18, timeZoneOfPatient),
                })
            }else{
                return setFilterTime({
                    startTime: '',
                    endTime: '',
                })
            }
        }
    }
    const setTheVisitType = () => {
        const visitTypeCode = visitTypeMap?.[findYourCareValues?.lookingFor?.trim()];
        setVisitType(visitTypeCode)
    }
    const handleSelectTime = (index, date, ProviderDetail) => {
        if (returnedErrorMessage) {
            setReturnedErrorMessage(false)
        }
        setTimeSelected(() => {
            if (timeSelected[index]) {
                providerDetails({}, {})
                if (showErrorMessage) {
                    setShowErrorMessage(false)
                }
                return {
                    [index]: false,
                }
            }
            return {
                [index]: true,
            }
        })
        if (!timeSelected[index]) {
            const hasOverlap = appointmentList.some((item) => {
                return (
                    moment(item.start).tz(loggedinPatiendata?.timezone || 'US/Pacific') <
                        moment(date.end_time).tz(loggedinPatiendata?.timezone || 'US/Pacific') &&
                    moment(item.end).tz(loggedinPatiendata?.timezone || 'US/Pacific') >
                        moment(date.start_time).tz(loggedinPatiendata?.timezone || 'US/Pacific')
                )
            })

            if (hasOverlap) {
                setShowErrorMessage(true)
                providerDetails({}, {})
            } else {
                setShowErrorMessage(false)
                providerDetails(date, ProviderDetail)
            }
        }
    }

    const handleCloseTimeBookingMode = () => {
        setTimeBooking(() => {
            return {
                0: false,
            }
        })
        setTimeSelected(() => {
            return {
                0: false,
            }
        })
        providerDetails({}, {})
        closeErrorMessage()
    }

    const handleOpenTimeBookingMode = async (index, id, slots= [], visitType={}) => {
        try {
            setAvailableList([])
            setTimeSelected(() => {
                return {
                    0: false,
                }
            })
            setTimeBooking(() => {
                return {
                    [index]: true,
                }
            })
            setAvailabilityLoading(true)
            const res = {
                data: {
                  data: {
                    availableSlotLists: slots,
                    appointments: [],
                    visitType: visitType
                  }
                }
              };
            let availableList =
                res?.data?.data?.availableSlotLists?.length &&
                res?.data?.data?.availableSlotLists.filter((item) =>
                    patientTimeZone(item?.start_time, loggedinPatiendata?.timezone).isSameOrAfter(
                        moment().tz(loggedinPatiendata?.timezone || 'US/Pacific'),
                    ),
                )
            const filteredAvailable =
                availableList.length &&
                (res?.data?.data?.appointments?.length > 0
                    ? availableList?.filter((slot) => {
                          return !res?.data?.data?.appointments.some((appointment) => {
                              return (
                                  moment(slot.start_time) < moment(appointment.end) &&
                                  moment(slot.end_time) > moment(appointment.start)
                              )
                          })
                      })
                    : availableList)
            setProviderVisitType(res?.data?.data?.visitType)
            setAvailableList(filteredAvailable || [])
            setAppointmentList(res?.data?.data?.appointments || [])
            setAvailabilityLoading(false)
        } catch (err) {
            setAvailabilityLoading(false)
        }
    }

    const openTheCalender = () => {
        setOpenCalender(true)
    }
    const closeTheCalender = () => {
        setOpenCalender(false)
    }
    const dateSelected = (value) => {
        setDisplayDate(value)
        handleSelectATimeValues(moment(value), 'date')
    }
    const getListOfProviderToBook = async (state = '', dob = '') => {
        try {
                setLoading(true)
                setListOfProvider([])
                const location = {
                    state: "CA"
                }
                const specialityType = findYourCareValues?.bookingWith === 'yes' ? 'HIV PREVENTION' : 'INFECTIOUS DISEASES'
                const payload = {
                    start_date: filterTime?.startTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                    end_date: filterTime?.endTime.format('YYYY-MM-DDTHH:mm:ss[Z]'),
                    is_morning: selectATimeValues?.morning,
                    is_afternoon: selectATimeValues?.afternoon,
                    is_evening: selectATimeValues?.evening,
                    timezone: timeZoneOfPatient || 'US/Pacific',
                    specialty:
                        findYourCareValues?.lookingFor.toLowerCase().trim() == 'psychiatrya' ||
                        findYourCareValues?.lookingFor.toLowerCase().trim() == 'psychiatryc'
                            ? 'psychiatry'
                            : findYourCareValues?.lookingFor.toLowerCase().trim(),
                    state: state || PatientCreateObject?.state, // this key added for advanceMD
                    visit_type: visitType, // this key added for advanceMD
                    age: calculateAge(dob ? dob : PatientCreateObject?.dob),
                    provider_details: null
                        // findYourCareValues?.lookingFor.toLowerCase().trim() == 'psychiatrya'
                        //     ? 18
                        //     : findYourCareValues?.lookingFor.toLowerCase().trim() == 'psychiatryc'
                        //     ? 17
                        //     : calculateAge(dob ? dob : PatientCreateObject?.dob),
                }
                const res = await providerListForBook(payload)
                if(res?.data?.data.length == 0){
                    transLate()
                    setOpenModal(true)
                }
                // const nowPatientTimeZone = moment().tz(timeZoneOfPatient || 'US/Pacific');
                // const nextBusinessDate = getNextTwoBusinessDays(nowPatientTimeZone, 5).format('yyyy-MM-DD')
                // const updatedList = res?.data?.data.map(provider => ({
                //     ...provider,
                //     dates: provider.dates.filter(dateObj =>
                //       moment.utc(dateObj.date).isSameOrBefore(moment.utc(nextBusinessDate), "day")
                //     ),
                //   }));
                setListOfProvider(res?.data?.data || [])
                setLoading(false)
        } catch (err) {
            console.log('err', err)
            setLoading(false)
            transLate()
            setOpenModal(true)
        }
    }
    const closeErrorMessage = () => {
        setShowErrorMessage(false)
    }

    const handleFilterOpenOrClose = (anchorEl = null) =>
        setFilterProps((prev) => ({
            ...prev,
            open: anchorEl,
        }))
        // const handleSelectATimeValues = (value, fieldName) => {
        //     setSelectSelectATimeValuesCalendar((state) => {
        //       if (fieldName === 'date' && state.evening && isWeekend(value)) {
        //         return {
        //           ...state,
        //           date: value,
        //           morning: false,
        //           afternoon: false,
        //           evening: false,
        //         };
        //       }else if(fieldName === 'date' && value.isSame(moment().tz('US/Pacific'), 'day')){
        //          const checkedValue = checkTimeForToday()
        //          return{
        //             ...state,
        //             morning: checkedValue?.morning ? false : state?.morning,
        //             afternoon: checkedValue?.afternoon ? false : state?.afternoon,
        //             evening: checkedValue?.evening ? false : state?.evening,
        //             date: value,
        //          }
        //       }
        //       return {
        //         ...state,
        //         [fieldName]: value,
        //       };
        //     });
        // }

    const handleFilterControl = useCallback(
        (fieldValue, fieldName) => {
            let filters = filterProps?.filters

            if (fieldValue) {
                filters = [
                    ...filters,
                    Filters.filter((item) => item?.toLowerCase() === fieldName)[0],
                ]
            } else {
                filters = filters?.filter((item) => item?.toLowerCase() !== fieldName)
            }

            if (filters?.length === 0) {
                notification('Atleast one filter should be selected!', 'warning')
                return
            }

            setFilterProps((prev) => ({ ...prev, filters }))
            handleSelectATimeValues(fieldValue, fieldName)
        },
        [selectATimeValues],
    )

    const headerText = useMemo(
        () =>
            listOfProvider?.length > 0
                ? `What date and time works best for you?`
                : !loading
                ? `Sorry! No provider was found that matched your selections.`
                : `Select the provider you want to book with!`,
        [listOfProvider, loading],
    )

    useEffect(() => {
        setSelectedTime()  
        handleCloseTimeBookingMode()
        setFilterProps({
            open: false,
            filters: Filters.filter((item) => {
                if (selectATimeValues[item?.toLowerCase()]) return item
        }),
        })
    }, [selectATimeValues])
    useEffect(()=>{
        if(filterTime.startTime){
            // handleFilterOpenOrClose()
            getListOfProviderToBook()
        }else{
            setListOfProvider([])
        }
    },[filterTime])
    useEffect(() => {
        if(findYourCareValues?.lookingFor){
            setTheVisitType()
        }
    }, [findYourCareValues?.lookingFor])
    useEffect(() => {
        showErrorMessage && setReturnedErrorMessage(false)
    }, [showErrorMessage])
    const checkTheTime = () => {
        const isToday = selectATimeValues.date.isSame(moment(), 'day')
        const weekendCheck = isWeekend(selectATimeValues.date)
        if (isToday) {
            const checkedValue = checkTimeForToday()
            setCheckDisableTime({
                ...checkedValue,
                weekend: weekendCheck,
            })
        } else {
            setCheckDisableTime({
                morning: false,
                afternoon: false,
                evening: false,
                weekend: weekendCheck,
            })
        }
    }
    React.useEffect(() => {
        checkTheTime()
    }, [selectATimeValues.date])
    return (
        <div className="booking_boxes provider_component">
            {showErrorMessage && !returnedErrorMessage && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '8px',
                        background: '#FFD9D8',
                        padding: '7px',
                    }}>
                    <img
                        src={closeIcon}
                        alt=""
                        onClick={() => {
                            closeErrorMessage()
                        }}
                        style={{ cursor: 'pointer' }}
                    />
                    <Typography className="error-message">
                        Sorry this appointment has been booked! Please select another.{' '}
                    </Typography>
                </div>
            )}
            {!returnedErrorMessage && !loading && (
                <div>
                    <Typography className="step-headers">{headerText}</Typography>
                </div>
            )}
            {!showErrorMessage && returnedErrorMessage && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '8px',
                            background: '#FFD9D8',
                            padding: '7px',
                        }}>
                        <img
                            src={closeIcon}
                            alt=""
                            onClick={() => {
                                setReturnedErrorMessage(false)
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <Typography className="error-message">
                            Sorry this appointment has been booked!
                        </Typography>
                    </div>
                    <Typography className="step-headers">
                        Please select another appointment!.{' '}
                    </Typography>
                </>
            )}

            {!loading && (
                <ProviderFilter
                    filterProps={filterProps}
                    handleFilterOpenOrClose={handleFilterOpenOrClose}
                    selectATimeProps={{ selectATimeValues, handleSelectATimeValues }}
                    onChangeCheckboxValue={handleFilterControl}
                    checkDisableTime={checkDisableTime}
                />
            )}
            {!loading && (
                <ProviderFilter
                    filterProps={filterProps}
                    handleFilterOpenOrClose={handleFilterOpenOrClose}
                    selectATimeProps={{ selectATimeValues, handleSelectATimeValues }}
                    onChangeCheckboxValue={handleFilterControl}
                    checkDisableTime={checkDisableTime}
                />
            )}

            {!loading && listOfProvider.length !== 0 && (
                <div className="body card-raw">
                    <div className="provider_header">
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.091 2.90862C15.9028 5.72047 15.9026 10.2793 13.091 13.091C10.2791 15.9027 5.7204 15.9027 2.90856 13.091C0.0968847 10.2793 0.0968847 5.72047 2.90856 2.90862C5.72024 0.0969447 10.279 0.0967847 13.091 2.90862ZM10.2705 5.96079L7.36728 8.86415L5.72904 7.22575C5.21352 6.71022 4.43032 7.49343 4.94584 8.00895L6.97576 10.0389C7.19208 10.2552 7.54264 10.2552 7.75896 10.0389L11.0538 6.74399C11.5694 6.22847 10.7862 5.44527 10.2705 5.96079ZM14.0921 7.99983C14.0921 4.63503 11.3644 1.9075 7.99976 1.9075C4.63496 1.9075 1.90744 4.63503 1.90744 7.99983C1.90744 11.3646 4.63496 14.0921 7.99976 14.0921C11.3646 14.0921 14.0921 11.3646 14.0921 7.99983Z"
                                fill="#15A452"
                            />
                        </svg>
                        <Typography>
                            We found{' '}
                            <b>
                                {listOfProvider.length}{' '}
                                {listOfProvider.length > 1 ? ' Providers' : ' Provider'}
                            </b>{' '}
                            for you to choose from!
                        </Typography>
                    </div>
                    <Typography className="phoneNumberSelectProvider">
                        If you need assistance call{' '}
                        <span style={{ color: '#5571c6', fontWeight: 500 }}>(855) 446-8628</span>
                    </Typography>

                    <div
                        className="provider_card_container"
                        style={{
                            position: 'relative',
                            maxHeight: showErrorMessage ? '70%' : '100%',
                        }}>
                        {listOfProvider.length > 0 &&
                            listOfProvider.map((providerItem, providerItemIndex) => {
                                return (
                                    <div
                                        key={providerItemIndex}
                                        className={`provider_card ${
                                            timeBooking[providerItemIndex]
                                                ? 'provider_card_diff'
                                                : ''
                                        }`}
                                        style={{
                                            background: '#FCFCFC',
                                            border: '1px solid #D0D0D0',
                                        }}>
                                        <div className="card_content">
                                            <div className="provider_card_content">
                                                <div
                                                    className={`left_section ${
                                                        timeBooking[providerItemIndex] ? 'mb-0' : ''
                                                    }`}>
                                                    <div>
                                                        {providerItem?.avatar ? (
                                                            <img
                                                                style={{
                                                                    borderRadius: '80px',
                                                                    border: '2px solid #D8D8D8',
                                                                }}
                                                                alt="avatar"
                                                                src={`data:image/jpeg;base64,${providerItem?.avatar}`} //we get the base64 image from advanceMd
                                                                height={63}
                                                                width={60}
                                                            />
                                                        ) : (
                                                            nameAvatar(
                                                                `${providerItem?.first_name} ${providerItem?.last_name}`,
                                                            )
                                                        )}
                                                    </div>
                                                    <div className="about_doctor">
                                                        <Typography
                                                            className="name"
                                                            style={{ color: '#3E3E3E' }}>
                                                            {/* from backend we recieved first name on last_name key and last name on first_name key for that reason we display flip */}
                                                            {`${providerItem?.first_name} ${providerItem?.last_name}`}
                                                        </Typography>
                                                        <Typography
                                                            className="practice"
                                                            style={{ color: '#3E3E3E' }}>
                                                            {specialityOfPrivider(
                                                                providerItem?.specialities,
                                                            )}
                                                        </Typography>
                                                        {isMobileView && (
                                                            <Typography
                                                                className="description"
                                                                style={{ color: '#3E3E3E' }}>
                                                                {providerItem?.description}
                                                            </Typography>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {!isMobileView && (
                                                <Typography
                                                    className="description_new"
                                                    style={{ color: '#3E3E3E' }}>
                                                    {providerItem?.description}
                                                </Typography>
                                            )}
                                            <Divider />
                                            {!timeBooking[providerItemIndex] &&
                                                (!isMobileView ? (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                        }}>
                                                        <Button
                                                            className="book_buttonNew"
                                                            onClick={() => {
                                                                setProviderDetailsModal(true)
                                                                setProviderDetailsForModal(
                                                                    providerItem,
                                                                )
                                                                transLate()
                                                            }}
                                                            variant="contained"
                                                            color="success">
                                                            See Appointment Times
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <Button
                                                        className="book_buttonNew"
                                                        onClick={() => {
                                                            setProviderDetailsModal(true)
                                                            setProviderDetailsForModal(providerItem)
                                                            transLate()
                                                        }}
                                                        variant="contained"
                                                        color="success">
                                                        See Appointment Times
                                                    </Button>
                                                ))}

                                            {timeBooking[providerItemIndex] && (
                                                <>
                                                    <Divider />
                                                    <div
                                                        className="time_select_container"
                                                        style={{
                                                            height: '138px',
                                                            overflow: 'auto',
                                                        }}>
                                                        {availabilityLoading && (
                                                            <div className="loadingAvailability">
                                                                <CircularProgress />
                                                            </div>
                                                        )}
                                                        {availableList.length > 0 &&
                                                            availableList.map(
                                                                (timeItem, timeItemIndex) => {
                                                                    return (
                                                                        <Button
                                                                            className={`time_item ${
                                                                                timeSelected[
                                                                                    timeItemIndex
                                                                                ]
                                                                                    ? 'time_item_selected'
                                                                                    : ''
                                                                            }`}
                                                                            disabled={patientTimeZone(
                                                                                timeItem?.start_time,
                                                                                loggedinPatiendata?.timezone,
                                                                            ).isSameOrBefore(
                                                                                moment().tz(
                                                                                    loggedinPatiendata?.timezone ||
                                                                                        'US/Pacific',
                                                                                ),
                                                                            )}
                                                                            onClick={() =>
                                                                                handleSelectTime(
                                                                                    timeItemIndex,
                                                                                    timeItem,
                                                                                    providerItem,
                                                                                )
                                                                            }
                                                                            key={timeItemIndex}
                                                                            variant="outlined"
                                                                            size="small">
                                                                            {patientTimeZone(
                                                                                timeItem?.start_time,
                                                                                loggedinPatiendata?.timezone,
                                                                            ).format('h:mm A')}
                                                                        </Button>
                                                                    )
                                                                },
                                                            )}
                                                        {availableList.length === 0 &&
                                                            !availabilityLoading && (
                                                                <Typography>
                                                                    No record found
                                                                </Typography>
                                                            )}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        {/* {listOfProvider.length === 0 && !loading && (
                            <NoProviderComponent
                                goToRequiredStep={goToRequiredStep}
                                clinicalPracticeNumber={'(855) 597-0701.'}
                            />
                        )} */}
                    </div>
                    {steps === 3.5 && (
                        <DemoGraphModal
                            isOpenModal={steps === 3.5}
                            setSteps={() => setSteps(3)}
                            steps={steps}
                            handleNextStep={handleNextStep}
                            isMobileView={isMobileView}
                            selctedProviderDetails={selctedProviderDetails}
                            backToProvider={(state, dob) => {
                                setSteps(3), setLoading(true)
                                getListOfProviderToBook(state, dob)
                            }}
                        />
                    )}
                    <Modal
                        open={providerDetailsModal}
                        onClose={() => {
                            providerDetails({}, {}), setProviderDetailsModal(false)
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description">
                        <div
                            className={classes?.modalCss}
                            style={{
                                height: isMobileView ? 'calc(100% - 100px)' : 'unset',
                                width: isMobileView ? '96%' : 'unset',
                            }}>
                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <IconButton
                                    onClick={() => {
                                        providerDetails({}, {}), setProviderDetailsModal(false)
                                    }}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <div>
                                <ProviderDetails
                                    providerDetailsForModal={providerDetailsForModal}
                                    isMobileView={isMobileView}
                                    providerDetails={providerDetails}
                                    closeModal={() => {
                                        providerDetails({}, {})
                                        setProviderDetailsModal(false)
                                    }}
                                    showDemoGraphy={() => {
                                        setProviderDetailsModal(false)
                                        setOpenReasonForvisit(true)
                                    }}
                                    specialty={findYourCareValues?.lookingFor.toLowerCase().trim()}
                                    visit_type={visitType}
                                    setProviderVisitType={setProviderVisitType}
                                    selctedValue={selectedTime}
                                    patientState={PatientCreateObject?.state}
                                />
                            </div>
                        </div>
                    </Modal>
                    <Dialog
                        open={openReasonForvisit}
                        onClose={() => {
                            setReasonForVisitText(''), setOpenReasonForvisit(false)
                        }}
                        PaperProps={{
                            style: {
                                width: isMobileView ? 'unset' : '1055px',
                                maxWidth: isMobileView ? 'unset' : '1055px',
                                height: 'unset',
                            },
                        }}>
                        <ReasonForVisitModal
                            reasonForVisitText={reasonForVisitText}
                            setReasonForVisitText={setReasonForVisitText}
                            onClose={() => {
                                setReasonForVisitText(''), setOpenReasonForvisit(false)
                            }}
                        />
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'end',
                                padding: '0px 23px 23px 23px',
                            }}>
                            <Button
                                className="providerDetailsButton"
                                disabled={reasonForVisitText.trim() == ''}
                                onClick={() => {
                                    setOpenReasonForvisit(false)
                                    handleNextStep()
                                }}>
                                <span>Continue</span>
                            </Button>
                        </div>
                    </Dialog>
                </div>
            )}
            {loading && (
                <div className="providerLoading">
                    <CircularProgress />
                    <div className="">
                        <Typography className="searchingProviderMessageText">
                            Searching for available appointment times!
                        </Typography>
                    </div>
                </div>
            )}
            <Dialog
                open={listOfProvider.length === 0 && openModal}
                // onClose={() => setOpenModal(false)}
                maxWidth={'md'}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        justifyItems: 'flex-end',
                        padding: '5px ',
                    }}>
                    {/* <IconButton onClick={() => setOpenModal(false)}>
                        <CloseIcon sx={{ color: "#303e4e" }}/>
                    </IconButton> */}
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '20px',
                        gap: '20px',
                    }}>
                    <Typography className="searchingProviderMessageText">
                        We couldn't find any appointments that match your search criteria.
                    </Typography>
                    <div style={{ width: '80%' }}>
                        <Typography className="noProviderFoundNew">
                            Please give us a call at
                            <span style={{ fontWeight: 550 }}> (855) 446-8628</span>. We're happy to
                            help you find a time that works!
                        </Typography>
                    </div>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => {
                            backButton()
                            transLate()
                        }}
                        style={{ background: '#5571C6', textTransform: 'none' }}>
                        Try Again
                    </Button>
                </div>
            </Dialog>
            {/* <div><input type='radio'/><span>Yes, this is my first time</span></div> */}
        </div>
    )
}

export default ProviderINT
